// hero__video
import Blue from "~/core";

new Blue({
	name: 'TableDetail',
	selector: "main",
	setup(main) {
		const triggers = [...main.querySelectorAll('.video-modal--trigger')];
		const modal = document.createElement("div");
		const overlay = document.createElement("div");
		const container = document.createElement("div");

		modal.classList.add("modal");
		overlay.classList.add("modal__overlay");
		container.classList.add("modal__container");

		overlay.insertAdjacentElement("afterbegin", container);
		modal.insertAdjacentElement("afterbegin", overlay);

		const openModal = (videos) => {
			let _data = JSON.parse(videos);
			let content = document.createElement("div");
			content.className = 'modal-dialog';
			content.innerHTML = `
				<div class="modal-dialog__close modal-close">
					<i class="glyph-close"></i>
				</div>
				<div class="modal-dialog__content">
					<div class="modal-dialog__video">
						<div class="modal-dialog__navigate prev">
							<i class="glyph-chevron-left"></i>
						</div>
						<iframe class="modal-dialog__embedded"
								data-page="1"
								src=${_data.list[0]}
	                            frameborder="0" 
								seamless
								allowfullscreen></iframe>
						<div class="modal-dialog__navigate next">
							<i class="glyph-chevron-right"></i>
						</div>
					</div>
					<div class="modal-dialog__description">
						<p class="pageCount">1 of ${_data.list.length}</p>
						<p>${_data.caption}</p>
					</div>
				</div>
			`;

			content.addEventListener("click", (e) => e.stopPropagation()); // prevent click on content from closing modal
			container.insertAdjacentElement("afterbegin", content);
			document.body.insertAdjacentElement("beforeend", modal);

			setTimeout(() => {
				const close = document.querySelector('.modal-close');
				const prev = document.querySelector('.modal-dialog__navigate.prev');
				const next = document.querySelector('.modal-dialog__navigate.next');
				const count = document.querySelector('.modal-dialog__content .pageCount');

				if (_data.list.length === 1) {
					next.classList.add('hidden');
					count.classList.add('hidden');
				} else {
					prev.classList.add('hidden');
					prev.addEventListener("click", () => changeVideo('prev', _data.list));
					next.addEventListener("click", () => changeVideo('next', _data.list));
				}

				close.addEventListener("click", closeModal);
				modal.classList.add("is-open");
			});
		};

		const changeVideo = (dir, items) => {
			const video = document.querySelector('.modal-dialog__embedded');
			const prev = document.querySelector('.modal-dialog__navigate.prev');
			const next = document.querySelector('.modal-dialog__navigate.next');
			const count = document.querySelector('.modal-dialog__content .pageCount');

			let _page = parseInt(video.getAttribute('data-page'));
			console.log(items);
			if (dir === 'prev') {
				_page = _page - 1
				if (_page === 1) {
					prev.classList.add('hidden');
				}
				next.classList.remove('hidden');
			} else {
				_page = _page + 1
				if (items.length === _page) {
					next.classList.add('hidden');
				}
				prev.classList.remove('hidden');
			}
			console.log(_page);
			console.log(items[_page - 1]);
			count.innerHTML = `${_page} of ${items.length}`
			video.setAttribute('data-page', _page.toString())
			video.setAttribute('src', items[_page - 1])

		}
		const closeModal = () => {
			const cleanup = (e) => {
				if (e.propertyName !== "opacity") return;
				modal.removeEventListener("transitionend", cleanup);
				container.innerHTML = "";
				modal.remove();
			};
			modal.addEventListener("transitionend", cleanup);
			modal.classList.remove("is-open");
		};

		//init
		overlay.addEventListener("click", closeModal);
		triggers.forEach((trigger) => {
			const videos = trigger.dataset.videos
			trigger.addEventListener("click", () => openModal(videos));
		});
	}
});
